import styled, { css } from 'styled-components'
import { Accordion, theme } from '@mtsdengi/ui-kit'
import { unAuthTheme } from '@mtsdengi/common'

const AccordionWrapper = styled.div`
  flex: 1 1 auto;
`

const AccordionStyled = css`
  border-radius: ${unAuthTheme.radiuses.md}px;

  > div:first-child {
    > div:first-child {
      font-size: ${theme.fonts.font_sizes.header.sm1}px;
      line-height: ${theme.fonts.line_heights.header.sm1}px;
    }
  }
`

const DesktopAccordion = styled(Accordion)`
  ${AccordionStyled}

  & > div:first-child {
    padding: ${theme.spacings.sm}px 0;
  }

  margin-bottom: ${theme.spacings.xs}px;

  &:last-child {
    margin-bottom: 0;
  }
`

const TabletAccordion = styled(Accordion)`
  ${AccordionStyled}
  padding: 0;

  > div:first-child {
    padding: 0;
  }

  &:not(:last-child) {
    margin-bottom: ${theme.spacings.md}px;
  }

  @media (min-width: ${theme.breakpoints.md}px) {
    display: none;
  }
`

const Wrapper = styled.div`
  display: flex;
  padding: ${theme.spacings.xs}px 0;
`

const Sections = styled.div`
  @media (min-width: ${theme.breakpoints.tablet}px) {
    flex: 0 0 284px;
    margin-right: ${theme.spacings.sm}px;
  }

  @media (min-width: ${theme.breakpoints.sm}px) {
    margin-right: ${theme.spacings.xl}px;
  }
`

const SectionButton = styled.div<{ isActive: boolean }>`
  cursor: pointer;
  font-family: ${theme.fonts.font_family_comp};
  font-size: ${theme.fonts.font_sizes.header.sm1}px;
  line-height: ${theme.fonts.line_heights.header.sm1}px;
  font-weight: ${theme.fonts.font_weights.medium};

  &:not(:last-child) {
    margin-bottom: ${theme.spacings.sm}px;
  }

  &:hover {
    color: ${theme.colors.violet.hover};
  }

  ${({ isActive }) => isActive && `color: ${theme.colors.violet.primary}`}
`

export const Styled = {
  AccordionWrapper,
  DesktopAccordion,
  TabletAccordion,
  Sections,
  Wrapper,
  SectionButton,
}
